import { t } from '@hefe/i18n';
import { Club } from '@hefe/models';
import { Col, Descriptions, Row, Typography } from 'antd';
import { environment } from '../../../../../environments/environment';

interface ClubPracticeTimesFrameComponentProps {
  club: Club;
}

export default function ClubPracticeTimesFrameComponent(
  props: ClubPracticeTimesFrameComponentProps
) {
  const { club } = props;

  const url = environment.landingUrl + '/practice-times?clubId=' + club.uuid;

  return (
    <Row>
      <Col xs={24}>
        <Typography.Paragraph>
          {t('practices.administration.practice_times.iframe.feature_info')}
        </Typography.Paragraph>
      </Col>
      <Col xs={24}>
        <Descriptions bordered column={1}>
          <Descriptions.Item
            label={t(
              'practices.administration.practice_times.iframe.link.title'
            )}
          >
            <Typography.Link href={url} target="_blank">
              {url}
            </Typography.Link>
          </Descriptions.Item>
          <Descriptions.Item
            label={t('practices.administration.practice_times.iframe.title')}
          >
            <Typography.Paragraph code>
              {`<iframe src="${url}" title="${t(
                'practices.administration.practice_times.iframe.title'
              )}" onload="this.width=window.innerWidth;this.height=window.innerHeight;" frameborder="0"></iframe>`}
            </Typography.Paragraph>
            <Typography.Paragraph>
              {t('practices.administration.practice_times.iframe.description')}
            </Typography.Paragraph>
          </Descriptions.Item>
        </Descriptions>
      </Col>
    </Row>
  );
}
